import * as types from '../constants/actionTypes';

// Fetch Home Data
export const fetchHomeDataRequest = () => ({
  type: types.FETCH_HOME_DATA_REQUEST
});

export const fetchHomeDataSuccess = (homeData) => ({
  type: types.FETCH_HOME_DATA_SUCCESS,
  payload: homeData
});

export const fetchHomeDataFailure = (error) => ({
  type: types.FETCH_HOME_DATA_FAILURE,
  payload: error
});